import { SequenceMenu, SimpleModal } from '@sequencehq/core-components'
import { RedRed60 } from '@sequencehq/core-components'
import { FC, useCallback } from 'react'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useMutation } from '@sequencehq/api'
import { useNotifications } from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'

export const DeleteSavedViewDialog: FC<{
  savedViewId: string
  onCancel: () => void
}> = ({ savedViewId, onCancel }) => {
  const { displayNotification } = useNotifications()
  const navigate = useNavigate()

  const deleteSavedViewMutator = useMutation(
    dashboard20240730Client.deleteSavedView
  )

  const onSubmit = useCallback(async () => {
    try {
      await deleteSavedViewMutator.mutateAsync({
        id: savedViewId
      })
    } catch {
      displayNotification('Failed to delete saved view', { type: 'error' })
      return false
    }

    displayNotification('Saved view deleted', { type: 'success' })
    navigate('/home')
    return true
  }, [
    deleteSavedViewMutator.mutateAsync,
    displayNotification,
    navigate,
    savedViewId
  ])

  return (
    <SimpleModal
      variant="dialog"
      data-testid="savedViews.deleteDialog"
      trigger={
        <SequenceMenu.Item
          label="Delete saved view"
          uuid="delete-saved-view"
          style={{ color: RedRed60 }}
        />
      }
      onSubmit={onSubmit}
      onClose={onCancel}
      title="Delete saved view"
      submitButtonText="Delete"
      submittingButtonText="Delete"
      isDestructive
      submitting={deleteSavedViewMutator.isPending}
      disableSubmitOnEnter
    >
      This will delete the saved view immediately. This action cannot
      be&nbsp;undone.
    </SimpleModal>
  )
}
